export interface HeaderInfo {
  company: string;
  effectiveDate: string;
  agreement: string;
  cycle: string;
  contactName: string;
  contactPhone: string;
}
